import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

import WpButton from 'Wpds/components/button/WpButton';
import { dateMMMDDYYYY } from 'Shared/utils/DateTime.utils';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import * as UsersSelectors from 'Shared/selectors/Users.selectors';
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';
import { getDraftFeedbackByWorkspaceUuid } from 'Shared/selectors/Feedbacks.selectors';

import './DraftFeedback.scss';

function DraftFeedback() {
  const history = useHistory();

  const currentUserId = useDeepEqualSelector(state => state.user.id);
  const workspaceId = useDeepEqualSelector(state => state.workspace.id);
  const draftFeedback = useDeepEqualSelector(getDraftFeedbackByWorkspaceUuid(workspaceId));
  const teammate = useSelector(state =>
    UsersSelectors.getUserByUserId(state, { userId: draftFeedback?.receiverId })
  ).toJS();
  const handleCompleteFeedbackClick = () =>
    history.push(PageUrlsUtil.makeEditFeedbackFormUrl(workspaceId, draftFeedback.uuid));

  if (!draftFeedback || draftFeedback.creatorId !== currentUserId) return null;
  const teammateName = teammate.label;

  return (
    <div className="DraftFeedback d-flex justify-content-between align-items-center flex-wrap p-3 mt-4">
      <div className="d-flex flex-column">
        <div className="DraftFeedback__title">Draft Feedback</div>
        <div className="DraftFeedback__description">
          {`You started feedback for ${teammateName} on ${dateMMMDDYYYY(draftFeedback.createdAt)}`}
        </div>
      </div>
      <div>
        <WpButton qaTest="complete-feedback-button" variant="secondary" onClick={handleCompleteFeedbackClick}>
          Complete Feedback
        </WpButton>
      </div>
    </div>
  );
}

export default DraftFeedback;
